import React from 'react';
import { Image } from 'antd';
import AppLogo from './../../assets/app_logo.png';

const NewFooter: React.FC = () => {
  return (
    <footer className="bg-[#C6FF00] text-white w-full md:pb-0 pb-[92px]">
       {/* <footer className="bg-[#005243] text-white md:px-24 md:h-27">< */}
       <div className="flex justify-center 2xl:max-w-7xl mx-auto md:pb-0 px-10 2xl:px-0">
        <div className="w-full flex md:flex-row md:justify-between flex-col justify-center items-center gap-5 md:gap-0 md:py-4 py-10">
          <div>
            {/* <div className="text-3xl font-bold">SpotGenie</div>
            <div className="text-gray-300">YOUR PARKING GUARDIAN</div> */}
            <Image src={AppLogo} preview={false} className='!h-12' />
          </div>
          <div className="flex flex-row items-center justify-center gap-2">
            {/* <img src={QRCode} alt="QR Code" className="w-12 h-12 inline-block" /> */}
            <div className='flex flex-col md:items-start items-center justify-center'>
              <div className="md:text-[21px] text-[18px] font-ibmcondensedregular text-black h-[27px] uppercase">BY Neomiee Technologies PVT LTD</div>
              <div className="text-[16px] font-ibmcondensedregular text-black">Support@SpotGenie.in</div>
            </div>
          </div>
        </div>
        </div>
    </footer>
  );
};

export default NewFooter;
